
/* injects from baggage-loader */

'use strict';

export default class StageBaseController {
    constructor($log, $rootScope, $state, $timeout, Dialog, Trophies, Session, requireLevel) {
        'ngInject';
        this.$log = $log;
        this.Dialog = Dialog;
        this.Trophies = Trophies;
        this.Session = Session;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;

        this.requireLevel = requireLevel;
    }

    $onInit(){    
    }

    // Player

    dropLife(){
        this.lifes--;
        if(this.lifes <= 0){
            this.forceFinishStage();
        }
    }

    finish(callback) {
        let { level, life } = this.Session.get().user;

        let newLevel = level + 1;
        let newLife = life + 1;

        if (level <= this.requireLevel) this.Session.updateUser({ level: newLevel, life: newLife });

        this.$timeout(() => {
            this.Dialog.showTrophy(true, callback);
        }, 1000);
    }

    onFinishFail(){
        let { life } = this.Session.get().user;
        let newLife = (life - 1);
        
        if(newLife < 0) {
            this.$state.go('main')
        } else {
            this.Session.updateUser({ life: (life - 1) })
        }
    }

    // UI
    toggleAbeldoBalloon(){
        this.ballons.abeldo.visible = !this.ballons.abeldo.visible;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-base.controller.js